/* tslint:disable */
/* eslint-disable */
/**
 * LogQS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const StatementEffect = {
  Allow: "allow",
  Deny: "deny",
} as const;
export type StatementEffect =
  (typeof StatementEffect)[keyof typeof StatementEffect];

export function StatementEffectFromJSON(json: any): StatementEffect {
  return StatementEffectFromJSONTyped(json, false);
}

export function StatementEffectFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StatementEffect {
  return json as StatementEffect;
}

export function StatementEffectToJSON(value?: StatementEffect | null): any {
  return value as any;
}
